import type { ParseError } from '@effect/schema/ParseResult'
import { isTagged } from 'effect/Predicate'

export const isParseError = (result: unknown): result is ParseError =>
  isTagged(result, 'ParseError')
